// 마지막으로 확인된 traffic_type 을 localStorage 에 남긴다.
//
// 왜 필요한가: 세션의 첫 이벤트(session_start, first_visit, 최초 page_view)는 JWT 를 읽기
// 전에 발생하므로, 그것만으로는 내부 직원의 접속을 절대 내부로 표시할 수 없다.
// 이 값을 남겨두면 _document 부트스트랩이 gtm.js 보다 먼저 동기로 읽어, 한 번이라도
// 로그인한 기기·브라우저에서는 두 번째 세션부터 첫 히트가 내부로 찍힌다.
//
// sessionStorage 가 아니라 localStorage 인 이유가 그것이다 — 탭을 닫아도 남아야 한다.
//
// traffic-type.ts 와 분리한 이유: resolveTrafficType() 은 숨은 쓰기가 없는 순수 술어로
// 남아야 하고, _document 스니펫은 Identity 타입 없이 키 문자열만 필요하다.

import { TRAFFIC_TYPE_STORAGE_KEY } from "@/shared/analytics/constants";
import type { TrafficType } from "@/shared/analytics/traffic-type";

/** 저장된 값이 없거나 스토리지가 막힌 환경이면 undefined. */
export function readStoredTrafficType(): TrafficType | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  try {
    const raw = window.localStorage.getItem(TRAFFIC_TYPE_STORAGE_KEY);
    return raw === "internal" || raw === "external" ? raw : undefined;
  } catch {
    // 시크릿 모드 등 localStorage 가 막힌 환경에서는 라벨 유지만 포기한다.
    return undefined;
  }
}

/**
 * 로그인 상태가 확정됐을 때만 호출한다. 게스트에게는 쓰지 않는다 —
 * 첫 방문자를 잘못 라벨링하지 않기 위한 것이다.
 *
 * 비내부 회사로 로그인하면 "external" 로 덮어써 낡은 "internal" 을 교정한다.
 * 로그아웃 시에는 지우지 않는다 — 로그아웃한 직원도 여전히 내부 트래픽이다.
 */
export function rememberTrafficType(value: TrafficType): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(TRAFFIC_TYPE_STORAGE_KEY, value);
  } catch {
    // 저장 실패(용량 초과/사생활 모드)는 무시한다. 이번 세션은 dataLayer push 로 커버된다.
  }
}
